import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { v4 } from 'uuid';
import { VariableSvgIconBase } from '@/components/ui/SvgIcon/Variable/VariableSvgIconBase';
export const CircleIcon = (props) => {
    const { className, color, size } = props;
    const svgId = useMemo(() => v4(), []); // eslint-disable-line @typescript-eslint/no-unused-vars
    return (_jsx(VariableSvgIconBase, Object.assign({ className: className, color: color, size: size }, { children: _jsx("svg", Object.assign({ height: '1em', viewBox: '0 0 12 12', width: '1em', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("circle", { cx: 4, cy: 4, fill: 'currentColor', r: 6, transform: 'translate(2 2)' }) })) })));
};
